/*
 * THE REDESIGN, PART 2: THE CARD LIST — one page for an occasion, All cards and search results (2026-10-08).
 * templates/page.cards.liquid (and page.occasion.liquid); the data and the shared pieces are assets/rd-finding.js (window.RDF).
 *
 * Built from Claude Design's Card List (the one component behind its Occasion Page, All Cards and Search Results),
 * Filter Panel and List Notice. The occasion page is All cards with the occasion filter on: the occasion is a chip
 * that can be removed, and removing it, or "Clear all", leaves All cards. One grid, no sections inside it: made for
 * the occasion first, then the cards whose cover suits it, then the generic ones (the catalogue's placement).
 *
 * THE ADDRESS (on the existing page /pages/occasions since the switch, 2026-10-08; addresses of their own are Pop List
 * seo-pages):  ?view=cards                                All cards
 *              &occasion=birthday                         the occasion page (the occasion as a filter)
 *              &who=dad&feel=Funny&subject=Flowers&series=…&artist=…&age=…&sign=…&style=…&colour=…&sort=newest|az
 *              &group=puns                                Pun intended (assets/pp-series.js isPun; 18 Oct)
 *              &q=my+dad+who+loves+fishing                search results, on this page
 *              &dir=b | &dir=c                            Claude Design's directions B (chips and sheet) and C (sentence);
 *                                                         A (filter column) is the default. Daniel, 7 Oct: options are
 *                                                         switches, never replacements.
 *              &sc=1                                      Colour and Style shown as filters too (Claude Design's switch)
 *              &design=<id>&from=<occasion>               a design's own address: this list behind its lightbox
 *              The preview bar that flips dir and sc shows only with &preview=1 (rd-finding.js PREVIEW).
 *
 * THE OLD SITE'S OCCASION PAGES (/pages/birthday and six more, templates/page.occasion.liquid) are this list at their
 * own address, the occasion given by the page (#rdf data-occasion, F.CFG.hostOcc) instead of &occasion=. Filters stay
 * on that address; taking the occasion off, or choosing another, moves to /pages/occasions?view=cards.
 *
 * THE SEARCH is the artist platform's finder (artists.picturepops.com/finder.json), the one the builder uses, not
 * Claude Design's stand-in of about twenty words. What it understood shows as terms; removing one re-ranks with the
 * edited reading (?read=), without asking the model again.
 */
(function () {
  'use strict';
  /* ONE LIST, TWO PLACES (2026-10-11). The card list mounts on its own page (templates/page.cards.liquid, below), and a
     big series page mounts it under its header (rd-series.js; Daniel, 11 Oct: "we need filtering on series pages… the
     Art History series has 115 and there's no filters… above a certain N, maybe yes"). There EMBED is
       { series: the series' name, every card of which is the list's base (not a filter: no chip, nothing in the
                 address, the page's own ?series=<slug> left alone),
         order:  id -> place in the series, the Featured order (the series' own numbers),
         tile:   d -> extra tile options (its "No. 3 of 115"),
         groups: the filter groups, in order; a group is offered only when at least two of its values have cards,
         find:   optional, the page's own search (Famous Cities' "Search for your city", 15 Oct): { q() the words,
                 score(d) 0 = not a match, higher = better (the best first in Featured order), none(q) the line when
                 nothing matches }. The page calls the returned render() as the words change. }
     and the list draws no head, search, shortcuts or foot of its own: the series page has them. */
  function mount(root, EMBED) {
  if (!root || !window.RDF) return;
  const F = window.RDF, esc = F.esc;
  const $ = (s) => root.querySelector(s);
  const KEYS = ['occ', 'who', 'feel', 'subj', 'series', 'artist', 'sign', 'age', 'style', 'colour', 'group'];   // group: ?group=puns (rd-finding.js GET.group)
  const phoneMq = window.matchMedia('(max-width: 760px)'), wideMq = window.matchMedia('(min-width: 1024px)');

  /* ---- state, from the address ------------------------------------------------------------------------------- */
  const st = { sel: {}, sort: 'featured', pages: 1, q: '', read: null, res: null, near: null, exact: null, note: '', v2: false, askedOcc: '', view: null, searchFailed: false, busy: false, sheet: false, open: {}, dir: 'a', sc: false };
  /* A design's own address (?view=cards&design=<id>&from=<occasion>) shows this list behind the design's lightbox
     (assets/rd-design.js): the occasion it came from, else All cards. */
  const onDesign = (p) => p.get('view') === 'cards' && !!p.get('design');
  /* The old occasion pages: the page's own occasion while the address is still that page's. */
  const HOST = F.CFG.hostOcc ? { occ: F.CFG.hostOcc, path: location.pathname } : null;
  const onHost = () => !!HOST && location.pathname === HOST.path;
  function readAddress() {
    const p = new URLSearchParams(location.search);
    st.sel = {};
    KEYS.forEach((k) => {
      if (EMBED && k === 'series') return;   // the page's own ?series=<slug>, not a filter
      let v = (p.get(k === 'occ' && onDesign(p) ? 'from' : F.PARAM[k]) || '').split(',').map((s) => s.trim()).filter(Boolean);
      if (k === 'occ' && !v.length && onHost()) v = [HOST.occ];
      if (k === 'series') v = F.uniq(v.map((s) => (F.canonSeries(s) || {}).name).filter(Boolean));
      if (v.length) st.sel[k] = v;
    });
    st.sort = ['newest', 'az'].includes(p.get('sort')) ? p.get('sort') : 'featured';
    st.dir = ['b', 'c'].includes(p.get('dir')) ? p.get('dir') : 'a';
    st.sc = p.get('sc') === '1';
    const q = (p.get('q') || '').replace(/\s+/g, ' ').trim().slice(0, 160);
    if (q !== st.q) { st.q = q; st.read = null; st.res = null; st.near = null; st.exact = null; st.note = ''; st.searchFailed = false; }
  }
  function address() {
    const p = new URLSearchParams(location.search);
    if (onDesign(p)) ['design', 'from', 'show'].forEach((k) => p.delete(k));
    KEYS.forEach((k) => { if (EMBED && k === 'series') return; const v = st.sel[k] || []; if (v.length) p.set(F.PARAM[k], v.join(',')); else p.delete(F.PARAM[k]); });
    if (st.sort !== 'featured') p.set('sort', st.sort); else p.delete('sort');
    if (st.q) p.set('q', st.q); else p.delete('q');
    if (onHost()) {
      const o = st.sel.occ || [];
      if (o.length === 1 && o[0] === HOST.occ) {   // still this occasion's page: its own address, the occasion implied
        p.delete(F.PARAM.occ);
        const r = p.toString().replace(/%2C/g, ',');
        return HOST.path + (r ? '?' + r : '');
      }
      p.delete('view');   // the occasion is off, or another: All cards, with whatever else is on
      return F.HREF.cards(p.toString().replace(/%2C/g, ','));
    }
    return location.pathname + '?' + p.toString().replace(/%2C/g, ',');
  }
  const occOf = () => ((st.sel.occ || []).length === 1 ? st.sel.occ[0] : '');

  /* ---- the search ---------------------------------------------------------------------------------------------- */
  /* THE CONTRACT WITH THE FINDER (25 Oct; Daniel: "go ahead and fix the search"). The words go as they were typed; the
     page's occasion goes beside them as &occ= (an occasion's page, or one occasion ticked, which draws as that page),
     never in front of them: "a sympathy card for tarot" made the occasion a must and the topic a preference, so tarot
     on Sympathy found 24 white flowers and no Tarot. &as= is the country the catalogue was answered for (rd-finding.js
     visitorAs), so the finder ranks only cards this list can show. The answer is { read, cards, exact, near, note }:
     the first `exact` cards truly match, `near` are the closest when that is few or none, `note` is an honest line to
     show. An older answer without `exact` is read as before: every card a match.
     ⛔ ONE ANSWER AT A TIME. Each ask is numbered and the one before it aborted; an answer that is not the latest is
     dropped, so a slow first search can never draw over a fast second (it did: no counter, no abort). A search that
     takes longer than ASK_MS is a failed one, with the failure line, never "Looking…" for ever. */
  const ASK_MS = 9000;
  let askN = 0, askCtl = null;
  function cancelAsk() { askN++; if (askCtl) { try { askCtl.abort(); } catch (e) { /* gone */ } askCtl = null; } st.busy = false; }
  function track(name, props) { try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props || {}); } catch (e) { /* analytics never stops a search */ } }
  const pageKind = () => (EMBED ? 'series' : occOf() ? 'occasion' : 'all');
  function ask(byRead, kind) {
    cancelAsk();
    const my = askN, occ = occOf(), as = F.visitorAs ? F.visitorAs() : '';
    const extra = (occ ? '&occ=' + encodeURIComponent(occ) : '') + (as ? '&as=' + encodeURIComponent(as) : '');
    const url = F.ORIGIN + '/finder.json?' + (byRead ? 'read=' + encodeURIComponent(JSON.stringify(byRead)) : 'q=' + encodeURIComponent(st.q)) + extra;
    const ctl = window.AbortController ? new AbortController() : null;
    askCtl = ctl;
    const t0 = Date.now(), q = st.q;
    st.busy = true; render();
    let timer = 0;
    const late = new Promise((_, no) => { timer = setTimeout(() => { if (ctl) { try { ctl.abort(); } catch (e) { /* gone */ } } no(new Error('finder timeout')); }, ASK_MS); });
    let j = null, failed = false;
    Promise.race([fetch(url, ctl ? { signal: ctl.signal } : undefined).then((r) => { if (!r.ok) throw new Error('finder ' + r.status); return r.json(); }), late])
      .then((x) => {
        if (my !== askN) return;
        j = x || {};
        st.read = j.read || {};
        st.res = (j.cards || []).map((c) => c.id).filter(Boolean);
        st.near = (j.near || []).map((c) => c.id).filter(Boolean);
        st.exact = typeof j.exact === 'number' && j.exact >= 0 ? Math.floor(j.exact) : null;   // null: an older answer
        st.note = typeof j.note === 'string' && j.note.trim() ? j.note.trim() : '';
        st.askedOcc = occ; st.v2 = st.exact !== null;
        st.searchFailed = false;
      })
      .catch(() => { if (my !== askN) return; failed = true; st.res = []; st.near = []; st.exact = null; st.note = ''; st.v2 = false; st.searchFailed = true; })
      .then(() => {
        clearTimeout(timer);
        if (my !== askN) return;
        if (askCtl === ctl) askCtl = null;
        st.busy = false; render();
        /* MEASURED (25 Oct): every search on these pages, so a zero-result rate exists before launch. q is kept as typed,
           as pp_finder_search keeps it (Daniel, 5 Oct: "keep raw text in posthog"). results is the finder's own count of
           true matches; shown and near are what this page could show of them in this visitor's catalogue. */
        const fire = () => { if (my !== askN) return; const v = st.view || {}; track('pp_search', {
          q: q, length: q.length, kind: kind || (byRead ? 'chip' : 'typed'), page: pageKind(), occ: occ || null,
          results: failed ? null : st.exact !== null ? st.exact : st.res.length, answered: failed ? null : st.res.length,
          shown: v.match || 0, near: v.close || 0, generic: failed ? 0 : v.generic || 0, missing: v.missing || 0, mode: v.mode || null,
          source: (j && j.via) || null, fell_back: (j && j.fellBack) || null, shape: failed ? null : st.v2 ? 'v2' : 'v1', note: !!st.note,
          failed: failed, ms: Date.now() - t0, country: F.countryBucket ? F.countryBucket() : null, as: as || null,
          occasion_read: ((st.read && st.read.occasions) || [])[0] || null, recipient_read: ((st.read && st.read.recipients) || [])[0] || null,
        }); };
        // what the page could show is known only once the cards are in (an answer can beat the catalogue)
        if (F.designs()) fire(); else F.load().then(() => { render(); fire(); }).catch(() => fire());
      });
  }
  /* What it understood, as terms that can be removed. The page's own occasion is not repeated as a term. Exclusions
     ("not funny") and the gentle mood (a loss, an illness: it takes away every light card) are rules too, so they show
     and can be removed like the rest (25 Oct: they were applied and never shown). */
  const MOOD_LABEL = { loss: 'Gentle cards', gentle: 'Gentle cards' };
  function terms() {
    const r = st.read || {}, out = [], occ = occOf();
    const add = (key, val, label, sub) => { if (label && !out.some((t) => t.label.toLowerCase() === String(label).toLowerCase())) out.push({ key, val, label: String(label), sub: sub || '' }); };
    (r.occasions || []).forEach((v) => { if (v !== occ) add('occasions', v, F.OCC_BY[v] ? F.OCC_BY[v].name : F.cap(v)); });
    (r.recipients || []).forEach((v) => add('recipients', v, F.WHO[v] || F.cap(v)));
    (r.subjects || []).forEach((v) => add('subjects', v, F.cap(v)));
    (r.tones || []).forEach((v) => add('tones', v, F.cap(v)));
    (r.motifs || []).forEach((v) => add('motifs', v, F.cap(v)));
    if (r.series) add('series', r.series, (F.canonSeries(r.series) || {}).name || r.series);
    if (r.credit) add('credit', r.credit, r.credit);
    if (r.zodiac) add('zodiac', r.zodiac, F.cap(r.zodiac));
    if (r.mood && MOOD_LABEL[r.mood]) add('mood', r.mood, MOOD_LABEL[r.mood]);
    const ex = r.exclude && typeof r.exclude === 'object' ? r.exclude : {};
    ['occasions', 'tones', 'subjects', 'motifs'].forEach((k) => (Array.isArray(ex[k]) ? ex[k] : []).forEach((v) =>
      add('exclude', v, 'Not ' + (k === 'occasions' && F.OCC_BY[v] ? F.inLine(F.OCC_BY[v]) : String(v).toLowerCase()), k)));
    return out;
  }
  const readEmpty = (r) => !['occasions', 'recipients', 'subjects', 'tones', 'motifs', 'artStyles', 'colors', 'words'].some((k) => Array.isArray(r[k]) && r[k].length) &&
    !r.series && !r.credit && !r.zodiac && !r.birthMonth;
  function dropTerm(i) {
    const t = terms()[i];
    if (!t || !st.read) return;
    const r = JSON.parse(JSON.stringify(st.read));
    if (t.key === 'exclude') { if (r.exclude && Array.isArray(r.exclude[t.sub])) r.exclude[t.sub] = r.exclude[t.sub].filter((v) => v !== t.val); }
    else if (Array.isArray(r[t.key])) r[t.key] = r[t.key].filter((v) => v !== t.val); else r[t.key] = null;
    // its words go too, or the re-rank still matches them in titles (a word that starts the term, or that the term starts)
    const val = String(t.val).toLowerCase();
    if (t.key !== 'exclude' && t.key !== 'mood' && Array.isArray(r.words)) r.words = r.words.filter((w) => { const x = String(w).toLowerCase(); return !(x.indexOf(val) === 0 || val.indexOf(x) === 0); });
    /* The last thing it read, removed: there is no search left, so the list goes back to what it was without one,
       never a page of generic cards under the search's name (25 Oct). */
    if (readEmpty(r)) { clearSearch(); return; }
    ask(r, 'chip');
  }
  function clearSearch() {
    cancelAsk();
    st.q = ''; st.res = null; st.near = null; st.exact = null; st.note = ''; st.read = null; st.searchFailed = false; st.pages = 1;
    update(true);
  }

  /* ---- drawing ----------------------------------------------------------------------------------------------- */
  const pill = (on) => (on ? ' is-on' : '');
  function sheetGroupsHtml(groups, mode) {
    const lim = mode === 'column' ? 5 : 8;
    return groups.map((g) => {
      if (!g.vals.length) return '';
      const open = !!st.open[g.k];
      const shown = open ? g.vals : g.vals.slice(0, lim).concat(g.vals.slice(lim).filter((v) => v.on));
      const vals = shown.map((v) => {
        const off = !v.on && !v.n, fk = g.k + ':' + v.v;
        const sw = g.k === 'colour' ? '<span class="rdf-sw" style="background:' + esc(F.SWATCH[v.v] || '#ccc') + '" aria-hidden="true"></span>' : '';
        return mode === 'column'
          ? '<button type="button" class="rdf-check' + pill(v.on) + (off ? ' is-off' : '') + '" role="checkbox" aria-checked="' + v.on + '"' + (off ? ' aria-disabled="true"' : '') +
            ' data-k="' + g.k + '" data-v="' + esc(v.v) + '" data-fk="c:' + esc(fk) + '"><span class="rdf-box" aria-hidden="true"></span>' + sw + '<span class="rdf-check__l">' + esc(v.label) + '</span><span class="rdf-n">' + v.n + '</span></button>'
          : '<button type="button" class="rdf-chip' + pill(v.on) + (off ? ' is-off' : '') + '" role="checkbox" aria-checked="' + v.on + '"' + (off ? ' aria-disabled="true"' : '') +
            ' data-k="' + g.k + '" data-v="' + esc(v.v) + '" data-fk="s:' + esc(fk) + '">' + (v.on ? '<span class="ic ic-check" aria-hidden="true"></span>' : '') + sw + esc(v.label) + '<span class="rdf-n">' + v.n + '</span></button>';
      }).join('');
      const more = g.vals.length > lim ? '<button type="button" class="rdf-more" data-more="' + g.k + '" aria-expanded="' + open + '" data-fk="m:' + mode + g.k + '">' + (open ? 'Show fewer' : 'Show all ' + g.vals.length) + '</button>' : '';
      return '<fieldset class="rdf-fg"><legend>' + esc(g.title) + '</legend>' + (mode === 'column' ? vals : '<div class="rdf-chips">' + vals + '</div>') + more + '</fieldset>';
    }).join('');
  }

  function render() {
    const phone = phoneMq.matches, wide = wideMq.matches, dir = st.dir, A = dir === 'a', B = dir === 'b', C = dir === 'c';
    const list0 = F.designs();
    root.setAttribute('data-dir', dir);
    drawSwitches();
    if (!list0) return;
    const occ = occOf(), O = occ ? F.OCC_BY[occ] : null, hard = F.HARD.includes(occ);
    const keys = EMBED ? EMBED.groups.slice() : F.groupsFor(occ, { styleColour: st.sc });
    // a filter in the address applies even where its group is not shown (Colour and Style without the switch)
    KEYS.forEach((k) => { if ((st.sel[k] || []).length && !keys.includes(k)) keys.push(k); });
    const findQ = EMBED && EMBED.find ? EMBED.find.q() : '', score = findQ ? new Map() : null;
    if (score) F.pool(occ).forEach((d) => { if (d.se === EMBED.series) score.set(d.id, EMBED.find.score(d)); });
    const base = EMBED ? F.pool(occ).filter((d) => d.se === EMBED.series && (!score || score.get(d.id) > 0)) : F.pool(occ), fx = F.facets(base, st.sel, keys, F.hiddenVals(occ));
    /* On a series page only the groups that split the series: two values or more with cards, and not every value
       counting the same cards (Art History's 115 are generic covers, on every occasion: 115 under each of 41 occasions
       said nothing). A group with a value ticked stays, so it can be unticked. */
    const splits = (g) => { const ns = g.vals.filter((v) => v.n > 0).map((v) => v.n); return ns.length >= 2 && new Set(ns).size > 1; };
    if (EMBED) fx.groups = fx.groups.filter((g) => g.k !== 'series' && (splits(g) || g.vals.some((v) => v.on)));
    const pos = (d) => (EMBED.order.has(d.id) ? EMBED.order.get(d.id) : 1e6);
    const list = EMBED && st.sort === 'featured' ? fx.list.slice().sort((a, b) => (score ? score.get(b.id) - score.get(a.id) : 0) || pos(a) - pos(b)) : F.sortList(fx.list, st.sort, occ), total = list.length;
    const nOther = Object.keys(st.sel).filter((k) => k !== 'occ').reduce((a, k) => a + st.sel[k].length, 0);
    const searching = !!st.q;
    /* SEARCH RESULTS FILTER TOO (Daniel, 15 Oct: "i need to add filtering on the left also for search results"). The
       column and the sheet work on what the search found, in the search's own order, and count over it, so a value
       says what ticking it leaves of these results. A search that finds nothing falls back to the generic cards, that
       suit anyone (Daniel, 15 Oct, over "my brother" at 0 cards: "it should show generic cards!"), on the occasion the
       search read when it read one, so a hard occasion stays gentle; those filter the same way. */
    /* WHAT THE SEARCH FOUND, IN THREE KINDS (25 Oct). `match`: the cards that truly match (the finder's first `exact`),
       under "Picked for". `close`: the rest of its cards and its `near` list, the closest it has, after the matches
       under a line, or alone under "Closest to" when nothing matches: never a dead end. `none`: nothing at all, or
       nothing this visitor's catalogue holds, so the generic cards that suit anyone, said plainly and never under the
       search's name. An id this page does not hold (another country's card, a design just taken down) is skipped, and
       counted (`missing`): when that leaves no match, the closest cards stand in, not an empty page. */
    const toD = (ids) => F.uniq(ids || []).map((id) => F.byId(id)).filter((d) => d && base.includes(d));
    let mode = '', matches = [], close = [], missing = 0;
    if (searching && st.res) {
      const ex = st.exact === null || st.exact === undefined ? st.res.length : Math.min(st.exact, st.res.length);
      const mIds = st.res.slice(0, ex), cIds = st.res.slice(ex).concat(st.near || []);
      matches = toD(mIds);
      close = toD(cIds).filter((d) => !matches.includes(d));
      missing = F.uniq(mIds.concat(cIds)).filter((id) => !F.byId(id)).length;
      mode = matches.length ? 'match' : close.length ? 'close' : 'none';
    }
    const readOcc = searching && st.read && (st.read.occasions || []).length === 1 && F.OCC_BY[st.read.occasions[0]] ? st.read.occasions[0] : '';
    const none = mode === 'none' && !st.busy && !st.searchFailed;
    const sPool = !mode ? null : none ? F.fillers(readOcc, [], Infinity) : mode === 'match' ? matches.concat(close) : close;
    /* The page's occasion, when the finder was told it (&occ=, a current answer): the finder already answered for that
       occasion, so it is not applied a second time over its cards, or tarot on Sympathy is emptied again by the page's
       own placement. With an older answer (no &occ= read) the occasion filters what came back, as before. */
    const trusted = st.v2 && st.askedOcc && occOf() === st.askedOcc && !none;
    const sSel = trusted ? Object.assign({}, st.sel, { occ: [] }) : st.sel, sKeys = trusted ? keys.filter((k) => k !== 'occ') : keys;
    const sfx = sPool ? F.facets(sPool, sSel, sKeys, F.hiddenVals(occ)) : null;
    if (sfx) fx.groups = trusted ? F.facets(sPool, st.sel, ['occ'], F.hiddenVals(occ)).groups.concat(sfx.groups) : sfx.groups;   // the occasion counted over these results too; ticking another asks again (toggle)
    /* ⛔ A SEARCH IS NEVER EMPTIED BY A FILTER (Daniel, 25 Oct: "Tarot" read as tarot card, 21 Tarot cards found, 0
       shown, because "Patterns with Meaning" was still ticked from before). A new search clears the filters from before
       (submit, below); a filter ticked on the results that would leave none of them is set aside: everything the
       search found is shown, with a line naming the filter and a button to clear it (theme 9f0dc94, held for this batch
       and re-applied here). Matches stay first, then the closest, in whatever order is chosen. */
    const kept = sfx ? sfx.list : null;
    const overFilter = !!(kept && !kept.length && sPool.length && !st.busy && !st.searchFailed);
    const pick = overFilter ? sPool : kept;
    const order = (l) => (st.sort === 'featured' ? l : F.sortList(l, st.sort, occ));
    const res = !pick ? null : mode === 'match' ? order(pick.filter((d) => matches.includes(d))).concat(order(pick.filter((d) => !matches.includes(d)))) : order(pick);
    const nMatch = res && mode === 'match' ? res.filter((d) => matches.includes(d)).length : 0;
    if (searching) st.view = { mode, match: nMatch, close: res && mode !== 'none' ? res.length - nMatch : 0, generic: res && mode === 'none' ? res.length : 0, missing };
    const count = searching ? (res ? res.length : 0) : total;
    const chips = [];
    KEYS.forEach((k) => (st.sel[k] || []).forEach((v) => chips.push({ k, v, label: F.valLabel(k, v) })));
    const fg = (k) => fx.groups.find((g) => g.k === k) || { vals: [] };

    /* the head */
    if (!EMBED && !onHost()) document.title = (O ? O.title : 'All cards') + ' · Picturepops';   // an occasion's own page keeps the server's title
    const hol = O && O.holiday ? F.orderByNotice(occ) : '';
    $('[data-rdf-headmain]').innerHTML =
      (O ? '<nav aria-label="Breadcrumb"><ol class="rdf-crumb"><li><a href="' + esc(F.HREF.occasions()) + '">Occasions</a></li><li aria-hidden="true">›</li><li aria-current="page">' + esc(O.name) + '</li></ol></nav>' : '') +
      '<h1 class="rdf-h1">' + esc(O ? O.title : chips.length ? 'Cards' : 'All cards') + ' <span class="rdf-h1__n">(' + total + ')</span></h1>' +
      '<p class="rdf-lead">' + esc(O ? O.line : 'Every design we make. Each one opens into four of your own photos.') + '</p>' + (hol ? '<div class="rdf-head__hol">' + hol + '</div>' : '');
    const ph = O ? O.ph : 'my dad, who loves fishing and old books';
    root.querySelectorAll('[data-rdf-q]').forEach((i) => { i.placeholder = ph; if (document.activeElement !== i) i.value = st.q; });
    syncClear();
    $('[data-rdf-finder]').hidden = C;

    /* direction C: the filters as a sentence */
    const sentence = $('[data-rdf-sentence]');
    sentence.hidden = !C;
    if (C) {
      const opts = (k, any) => [['', any]].concat(fg(k).vals.filter((v) => v.n > 0 || v.on).map((v) => [v.v, k === 'occ' ? F.inLine(F.OCC_BY[v.v] || { name: v.label }) : v.label.toLowerCase()]));
      const pick = (k, any, aria) => {
        const val = (st.sel[k] || [])[0] || '', o = opts(k, any), cur = (o.find(([v]) => v === val) || o[0])[1];
        // The select sits invisibly over its own words, so each blank is as wide as what it says, as a sentence is.
        return '<label class="rdf-pick' + (val ? ' is-set' : '') + '"><span class="sr">' + esc(aria) + '</span><span class="rdf-pick__w" aria-hidden="true">' + esc(cur) + '</span>' +
          '<select data-pick="' + k + '" data-fk="p:' + k + '">' +
          o.map(([v, l]) => '<option value="' + esc(v) + '"' + (v === val ? ' selected' : '') + '>' + esc(l) + '</option>').join('') + '</select><span class="ic ic-chev" aria-hidden="true"></span></label>';
      };
      $('[data-rdf-words]').innerHTML = '<span>A</span>' + pick('occ', 'any occasion', 'Occasion') + '<span>card for</span>' + pick('who', 'anyone', 'Who it’s for') +
        '<span>that feels</span>' + pick('feel', 'any way', 'Feel') + '<span>with</span>' + pick('subj', 'anything', 'Subject') + '<span>on it.</span>';
    }

    /* The circles: the homepage's series row (Daniel, 15 Oct: "replace the circles at the top there with the same circles
       of the series from the homepage"). Until then five round shortcuts (For Mom, For Dad, Funny ones…), each the same
       grid with one more filter on. Same list, order, names, links and look as the homepage's (assets/pp-series.js
       list(), rd-shell.css .ser), read from this page's designs as a series page's Other series does. Drawn again only
       when the list changes (the Artist Pool's titles arriving), so a filter never scrolls the row back to its start. */
    const scEl = $('[data-rdf-shortcuts]'), S = window.PP_SERIES;
    // Not on an occasion's page (Daniel, 12 Oct: "we can lose the circles - it can be confusing"), a search or a series page
    const serList = !S || EMBED || C || searching || occ ? [] : S.list(list0.map((d) => ({ id: d.id, se: d.se, no: d.seNo, styles: d.style, img: d.front, n: d.n })), '', F.pool2());
    scEl.hidden = serList.length < 2;
    const serKey = JSON.stringify(serList.map((x) => [x.href, x.t || x.s, x.n, x.img]));
    if (!scEl.hidden && serKey !== drawnSer) {
      drawnSer = serKey;
      scEl.innerHTML = '<nav class="ser pp-sc" aria-label="Our series"><button type="button" class="pp-sc__btn prev" tabindex="-1" aria-label="Scroll back" data-sc="-1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button>' +
        '<ul class="ser-row pp-sc__row" data-sc-row>' + serList.map((x) => '<li><a class="ser-i" href="' + esc(x.href) + '" aria-label="' + esc((x.t || x.s) + ', ' + x.n + (x.n === 1 ? ' design' : ' designs')) + '">' +
          '<span class="ser-img"><img src="' + esc(F.small(x.img, 200)) + '" crossorigin="anonymous" alt="" width="84" height="84" loading="lazy" decoding="async" draggable="false"><span class="rdf-paper" aria-hidden="true"></span></span><span class="ser-n">' + esc(x.t || x.s) + '</span></a></li>').join('') + '</ul>' +
        '<button type="button" class="pp-sc__btn next" tabindex="-1" aria-label="Scroll on" data-sc="1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button></nav>';
      S.scroller(scEl.querySelector('.ser')).hint();
    }

    /* search results head: "Picked for" only over cards that truly match (25 Oct; it headed 24 sympathy flowers for
       "tarot"), "Closest to" over the closest, and the generic cards never under the search's name */
    const searchHead = (m) => (m === 'close' ? 'Closest to “' + st.q + '”' : m === 'none' ? 'Nothing yet for “' + st.q + '”' : 'Picked for “' + st.q + '”');
    const sh = $('[data-rdf-searchhead]');
    sh.hidden = !searching;
    if (searching) {
      const ts = st.searchFailed ? [] : terms();
      sh.innerHTML = '<div class="rdf-sh__row"><h2 class="rdf-h2">' + esc(searchHead(st.busy || st.searchFailed ? 'match' : mode)) + ' <span class="rdf-h2__n">' + (st.busy ? 'Looking…' : res && !none && !st.searchFailed ? res.length + (res.length === 1 ? ' card' : ' cards') : '') + '</span></h2>' +
        '<button type="button" class="rdf-link" data-clear-q data-fk="cq">Clear</button></div>' +
        (ts.length ? '<div class="rdf-terms"><span>Reading it as:</span><ul aria-label="What we understood">' + ts.map((t, i) => '<li><button type="button" class="rdf-chip is-soft" data-term="' + i + '" aria-label="Remove ' + esc(t.label) + '" data-fk="t:' + i + '">' + esc(t.label) + '<span class="ic ic-x" aria-hidden="true"></span></button></li>').join('') + '</ul></div>' : '');
    }

    /* tools: Filters, count, sort; quick chips; the chosen filters */
    const tools = $('[data-rdf-tools]');
    tools.hidden = searching && !res;   // while the search is looking there is nothing to count yet
    const column = A && wide;
    const filtersLabel = (C ? 'More filters' : B && !phone ? 'All filters' : 'Filters') + (chips.length ? ' (' + chips.length + ')' : '');
    const quick = C ? [] : fg('feel').vals.map((v) => ['feel', v]).concat(fg('subj').vals.filter((v) => v.n > 0).sort((a, b) => b.n - a.n).slice(0, phone ? 3 : 4).map((v) => ['subj', v]))
      .filter(([, v]) => v.n > 0 || v.on);
    tools.innerHTML = '<div class="rdf-bar"><div class="rdf-bar__l">' +
      (!column ? '<button type="button" class="rdf-filters" data-open-sheet aria-haspopup="dialog" data-fk="fb"><span class="ic ic-sliders" aria-hidden="true"></span>' + esc(filtersLabel) + '</button>' : '') +
      '<p class="rdf-count" aria-live="polite">' + count + (count === 1 ? ' design' : ' designs') + '</p></div>' +
      '<label class="rdf-sort">Sort <span class="rdf-select"><select data-sort data-fk="sort"><option value="featured"' + (st.sort === 'featured' ? ' selected' : '') + '>' + (EMBED ? 'Series order' : searching && !none ? 'Best match' : 'Featured') + '</option><option value="newest"' + (st.sort === 'newest' ? ' selected' : '') + '>Newest</option><option value="az"' + (st.sort === 'az' ? ' selected' : '') + '>A to Z</option></select><span class="ic ic-chev" aria-hidden="true"></span></span></label></div>' +
      (quick.length ? '<div class="rdf-quick"><ul aria-label="Quick filters">' + quick.map(([k, v]) => '<li><button type="button" class="rdf-chip is-pill' + pill(v.on) + '" aria-pressed="' + v.on + '" data-k="' + k + '" data-v="' + esc(v.v) + '" data-fk="q:' + k + v.v + '">' + esc(v.label) + '<span class="rdf-n">' + v.n + '</span></button></li>').join('') + '</ul></div>' : '') +
      (chips.length ? '<div class="rdf-showing"><span>Showing:</span>' + chips.map((c) => '<button type="button" class="rdf-chip is-soft" data-drop-k="' + c.k + '" data-v="' + esc(c.v) + '" aria-label="Remove filter: ' + esc(c.label) + '" data-fk="x:' + c.k + c.v + '">' + esc(c.label) + '<span class="ic ic-x" aria-hidden="true"></span></button>').join('') +
        '<button type="button" class="rdf-link" data-clear-all data-fk="ca">Clear all</button></div>' : '');

    /* the column (direction A, wide screens) */
    const col = $('[data-rdf-col]');
    col.hidden = !column;
    if (column) col.innerHTML = '<div role="group" aria-label="Filters">' + sheetGroupsHtml(fx.groups, 'column') + '</div>';

    /* Thin and empty: one calm line above the grid, then cards that suit (no section heading). Counted on every card
       the page shows, made for it, suiting it or generic (Daniel, 8 Oct: "We have lots of designs that are good for
       sympathy"; the first rule counted only the cards made for it, and said "No sympathy designs yet" over 60 of them).
       "None yet" only when the page would show nothing; "only a few" under 6; otherwise no line at all. */
    const thin = !EMBED && !!O && !searching && !nOther && total < 6;   // a series page never fills with cards from outside it
    const fill = thin ? F.fillers(occ, list, 12) : [];
    const thinLine = !thin ? '' : total === 0
      ? 'No ' + F.inLine(O) + ' designs yet. Every card carries your own words, and ' + (hard ? 'these are gentle enough for it.' : 'these suit almost anything.')
      : 'Only ' + total + ' ' + F.inLine(O) + ' design' + (total === 1 ? '' : 's') + ' so far. After ' + (total === 1 ? 'it' : 'them') + ', cards that suit it too.';
    const shown = searching ? res || [] : list.concat(fill);
    // a different list (filters, sort, search, back and forward) starts from its first batch
    const key = listKey();
    if (key !== shownKey) { shownKey = key; st.pages = 1; }
    const per = phone ? (B ? 6 : 8) : 12, limit = per * st.pages;
    const motion = phone ? 'none' : hard ? 'lift' : 'tilt';
    const large = B || !phone;
    let notes = '';
    if (thin) notes += F.notice('thin', thinLine);
    if (st.searchFailed) notes += F.notice('error', 'The search did not answer just now. Try again in a moment.');
    else if (searching && res && !st.busy) {
      if (none) notes += sPool.length ? F.notice('thin', 'Nothing made just for that yet. These suit anyone, and every card carries your own words.')
        : F.notice('empty', 'Nothing matched that yet. Try fewer words.', 'Or remove a word above.');
      // the finder's own honest line (a gentle search with few cards made for it; a miss), else ours for a miss
      else if (mode === 'close') notes += F.notice('thin', st.note || 'We don’t have a card for that yet. These are the closest we have.');
      else if (st.note) notes += F.notice('thin', st.note);
      const fChips = trusted ? chips.filter((c) => c.k !== 'occ') : chips;
      if (overFilter) notes += F.notice('thin', 'None of these are in ' + (fChips.length === 1 ? fChips[0].label : 'your filters') + ', so here are all ' + res.length + '.', '', ['Clear the filters', 'data-clear-filters data-fk="cf"']);
    }
    else if (findQ && !base.length) notes += F.notice('empty', EMBED.find.none(findQ), 'Try another spelling, or a city nearby.');
    else if (!searching && !total && !thin) notes += F.notice('empty', 'No card matches all of these yet.', '', ['Clear the filters', 'data-clear-filters data-fk="cf"']);
    $('[data-rdf-notes]').innerHTML = notes;
    const grid = $('[data-rdf-grid]');
    grid.setAttribute('aria-label', (searching ? searchHead(mode).replace(/[“”]/g, '') : O ? O.title : 'All cards') + ', ' + shown.length + ' cards');
    /* A search that read one occasion opens its cards on that occasion, so the lightbox's inside reads its words
       ("mother's day" opened Snow Crystal No. 1093 saying "For a good friend", 9 Oct). */
    const tileOpts = { occ: occ || readOcc, motion, size: large ? 'large' : 'regular' };
    /* THE DIVIDER (Daniel, 19 Oct: "It's okay to have generic cards after the Halloween-specific ones, but we need a
       divider"). On an occasion's list in the featured order, the cards made for it come first, then a line, then the
       generic cards that suit it (rd-finding.js isOwn; the ones that belong to another occasion or another time of
       year are not on the page at all, rd-finding.js misfit). With nothing made for it yet, the line comes first. */
    /* A search's matches, then its closest cards: the same divider, saying so (25 Oct). */
    const sSplit = searching && mode === 'match' && res && res.length > nMatch ? nMatch : -1;
    const split = sSplit >= 0 ? sSplit : O && !EMBED && !searching && st.sort === 'featured' ? list.findIndex((d) => !F.isOwn(d, occ)) : -1;
    const splitHtml = split < 0 ? '' : sSplit >= 0
      ? '<li class="rdf-split"><h2 class="rdf-split__h">' + esc('Closest to “' + st.q + '”') + '</h2><p class="rdf-split__p">' + esc('Not an exact match, but near it. The words inside are yours.') + '</p></li>'
      : (() => {
      const nm = O.holiday ? O.name : F.inLine(O);
      return '<li class="rdf-split"><h2 class="rdf-split__h">' + esc((split ? 'More cards that work for ' : 'Cards that work for ') + nm) + '</h2>' +
        '<p class="rdf-split__p">' + esc(split ? 'Not made just for ' + nm + ', but right for it. The words inside are yours.' : 'Nothing made just for ' + nm + ' yet. These suit it, and the words inside are yours.') + '</p></li>';
    })();
    const tiles = (from, to) => shown.slice(from, to).map((d, i) => (from + i === split ? splitHtml : '') + F.tile(d, Object.assign({ eager: from + i < 3 }, tileOpts, EMBED ? EMBED.tile(d) : null))).join('');
    grid.innerHTML = tiles(0, limit);
    G = { shown, per, tileOpts, tiles, n: Math.min(limit, shown.length) };
    drawMore();

    /* below the grid: about the occasion (our paragraph), its series, related occasions */
    const foot = $('[data-rdf-foot]');
    foot.hidden = !O || searching;
    if (O && !searching) {
      const all = F.designs();
      const series = (F.SERIES_FOR[occ] || []).map((sn) => { const m = all.filter((d) => d.se === sn); return m.length ? { sn, n: m.length, img: m[0].front } : null; }).filter(Boolean);
      const related = (F.RELATED[occ] || F.GUIDE.filter((o) => o.group === O.group && o.h !== occ).slice(0, 4).map((o) => o.h)).map((h) => ({ o: F.OCC_BY[h], n: F.countFor(h) }));
      const lower = O.holiday ? O.name : O.name.toLowerCase();
      /* The paragraph about the occasion: ours, approved on 2026-10-08 (snippets/rd-words.liquid, RDF.WORDS.about). An
         occasion without one shows no paragraph; in preview its room is marked instead. */
      const about = F.WORDS.about[occ] || '';
      foot.classList.toggle('is-noabout', !about && !F.PREVIEW);
      foot.innerHTML = (about || F.PREVIEW ? '<section aria-labelledby="rdf-about" class="rdf-about"><h2 id="rdf-about" class="rdf-h3">About ' + esc(lower) + ' cards</h2>' +
        (about ? '<p>' + F.wordsHtml(about) + '</p>'
          : '<!-- PLACEHOLDER: the paragraph about this occasion is ours to write (80-120 words, for people and search engines). Not written yet. -->' +
            '<div class="rdf-room">Room for a short paragraph, about 80 to 120 words, written by Picturepops for people and search engines.</div>') + '</section>' : '') +
        '<div class="rdf-foot__side">' +
        (series.length ? '<section aria-labelledby="rdf-ser"><h2 id="rdf-ser" class="rdf-over">Series for ' + esc(lower) + '</h2><ul class="rdf-serlinks">' + series.map((s) =>
          '<li><a href="' + esc(F.seriesHref(s.sn)) + '"><img src="' + esc(F.small(s.img, 200)) + '" alt="" loading="lazy">' + esc(F.seriesTitle(s.sn)) + '<span>' + s.n + '</span></a></li>').join('') + '</ul></section>' : '') +
        '<section aria-labelledby="rdf-rel"><h2 id="rdf-rel" class="rdf-over">Related occasions</h2><ul class="rdf-rel">' + related.map((r) =>
          '<li><a href="' + esc(F.HREF.occasion(r.o.h)) + '">' + esc(r.o.name) + '<span>' + (r.n ? r.n : 'soon') + '</span></a></li>').join('') + '</ul></section></div>';
    }

    /* the sheet (phones) or drawer (desktop, directions B and C, and A below 1024 px) */
    const sheet = $('[data-rdf-sheet]');
    sheet.hidden = !st.sheet;
    sheet.className = 'rdf-sheet ' + (phone ? 'is-sheet' : 'is-drawer');
    if (st.sheet) {
      $('[data-rdf-sheet-body]').innerHTML = sheetGroupsHtml(fx.groups, 'sheet');
      $('[data-rdf-show]').textContent = 'Show ' + count + (count === 1 ? ' card' : ' cards');
    }
    document.documentElement.classList.toggle('rdf-locked', st.sheet);

    /* The dock and the nav's button used to carry the occasion into the builder here (?occasion= with no design),
       which landed on the old builder's design picker. Since 2026-10-09 (Daniel) Design a card goes to All cards,
       the address the shell ships, and a design is chosen here: the lightbox's button carries it into the builder. */
  }

  /* ---- MORE CARDS AS THE VISITOR SCROLLS (Daniel, 11 Oct: "in the filtered views I want ... the loading of new cards
     to be automatic"). Every card is already in the browser (F.load), so a batch is only more tiles: appended to the
     grid, never a re-render, so the tiles above stay where they are and keep their pictures. A watcher sits on the
     "Show more" box and adds the next batch when the box comes within about a screen and a half of view; after each
     batch it is watched afresh, which asks again at once, so a short batch on a tall screen keeps going until the
     screen is full. One batch at a time, in the list's own order.
     ⛔ THE BUTTON STAYS. It is the fallback: without IntersectionObserver nothing watches and the button is the way, as
     before 11 Oct; with it, the button is still there for a keyboard and for anyone faster than the watcher. Changing a
     filter, the sort or the search renders the list from its first batch (st.pages = 1), as it always did. */
  let G = null, io = null, adding = false;
  const MARGIN = Math.round(Math.max(800, window.innerHeight * 1.5));
  function drawMore() {
    const box = $('[data-rdf-more]');
    if (!G) { box.innerHTML = ''; return; }
    const left = G.shown.length - G.n;
    box.innerHTML = left > 0
      ? '<p aria-live="polite">' + G.n + ' of ' + G.shown.length + ' shown</p><button type="button" class="rdf-btn-ghost is-lg" data-more-cards data-fk="mc">Show ' + Math.min(G.per, left) + ' more</button>'
      // the end: said once the list has run past its first batch, so a short list ends quietly
      : G.n > G.per ? '<p class="rdf-moreend">All ' + G.n + ' shown</p>' : '';
    watch();
  }
  function watch() {
    if (!io) return;
    io.disconnect();
    const box = $('[data-rdf-more]');
    if (G && G.n < G.shown.length) { io.observe(box); setTimeout(() => maybeMore(true), 0); }
  }
  /* The one test every trigger makes: is the box within the margin below the view, or already above it? Above it
     (a jump to the footer) a scroll adds one batch and no more: the browser keeps the view on the footer while cards
     are added above it (scroll anchoring), so going on by itself from there loaded all 392 at once on a phone. */
  function maybeMore(chained) {
    if (!io || adding || !G || G.n >= G.shown.length) return;
    const box = $('[data-rdf-more]');
    if (!box || box.offsetParent === null) return;
    const r = box.getBoundingClientRect();
    if (r.top < window.innerHeight + MARGIN && !(chained && r.bottom < 0)) addMore(false);
  }
  /* The next batch. `focus`: the button was used, so the keyboard goes on to the first new card. */
  function addMore(focus) {
    if (adding || !G || G.n >= G.shown.length) return;
    adding = true;
    try {
      const from = G.n, to = Math.min(from + G.per, G.shown.length);
      const grid = $('[data-rdf-grid]');
      const before = grid.children.length;
      grid.insertAdjacentHTML('beforeend', G.tiles(from, to));
      G.n = to;
      st.pages = Math.ceil(to / G.per);
      if (focus) { const a = grid.children[before] && grid.children[before].querySelector('a'); if (a) a.focus({ preventScroll: false }); }
    } finally { adding = false; }
    drawMore();
  }
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) maybeMore(); }, { rootMargin: '0px 0px ' + MARGIN + 'px 0px' });
    /* A jump straight past the box (End, a dragged scrollbar, a fling on a long phone footer) leaves it above the view
       without ever crossing into it, and the watcher says nothing. So a scroll also asks, at most every 150 ms:
       is the box above the bottom of the view plus the margin? (Measured 11 Oct: on a phone a jump to the end stopped
       at 16 of 392 without this.) */
    let lastAsk = 0, trail = 0;
    window.addEventListener('scroll', () => {
      const now = Date.now();
      clearTimeout(trail);
      if (now - lastAsk < 150) { trail = setTimeout(maybeMore, 160); return; }   // and once more when the scroll stops
      lastAsk = now;
      maybeMore();
    }, { passive: true });
  }
  /* Back to the list from elsewhere (a card's page, the builder) when the browser did not keep the page: the batches
     that were showing come back, and the place on the page with them. Kept per address for this tab only. */
  const BACK = 'rdfList:';
  const backKey = () => BACK + location.pathname + location.search;
  window.addEventListener('pagehide', () => {
    try { if (G && !onDesign(new URLSearchParams(location.search))) sessionStorage.setItem(backKey(), JSON.stringify({ pages: st.pages, y: Math.round(window.scrollY) })); } catch (e) { /* private mode: nothing kept */ }
  });
  function cameBack() {
    try {
      const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (!nav || nav.type !== 'back_forward') return null;
      const v = JSON.parse(sessionStorage.getItem(backKey()) || 'null');
      return v && v.pages > 0 ? v : null;
    } catch (e) { return null; }
  }

  /* The preview's own switches: the three directions and Colour and Style. Not part of the design; a bar for
     comparing, with &preview=1 only (rd-finding.js PREVIEW). */
  function drawSwitches() {
    const el = $('[data-rdf-switches]');
    if (!el) return;
    el.hidden = !F.PREVIEW;
    if (!F.PREVIEW) { el.innerHTML = ''; return; }
    const link = (k, v, label, on) => {
      const p = new URLSearchParams(location.search);
      if (onDesign(p)) { if (p.get('from')) p.set('occasion', p.get('from')); ['design', 'from', 'show'].forEach((x) => p.delete(x)); }
      if (v) p.set(k, v); else p.delete(k);
      return '<a href="' + esc(location.pathname + '?' + p.toString().replace(/%2C/g, ',')) + '"' + (on ? ' aria-current="true"' : '') + '>' + esc(label) + '</a>';
    };
    // Daniel, 8 Oct: direction A, and Colour and Style off. The others stay here to compare until the site switches over.
    el.innerHTML = '<span>Preview</span><span class="rdf-sw-g">Direction ' + link('dir', '', 'A · Filter column (chosen)', st.dir === 'a') + link('dir', 'b', 'B · Chips and sheet', st.dir === 'b') + link('dir', 'c', 'C · Sentence', st.dir === 'c') + '</span>' +
      '<span class="rdf-sw-g">Colour and Style ' + link('sc', '', 'Off (chosen)', !st.sc) + link('sc', '1', 'On', st.sc) + '</span>';
  }

  /* Re-render, keeping focus on the control that was used (each carries data-fk). */
  function update(push) {
    const fk = document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('data-fk');
    if (push) history.pushState(null, '', address()); else history.replaceState(history.state, '', address());
    render();
    if (fk) { const el = root.querySelector('[data-fk="' + (window.CSS && CSS.escape ? CSS.escape(fk) : fk) + '"]'); if (el) el.focus({ preventScroll: true }); }
  }
  function toggle(k, v, only) {
    const cur = st.sel[k] || [];
    st.sel[k] = cur.includes(v) ? cur.filter((x) => x !== v) : only ? [v] : cur.concat(v);
    if (!st.sel[k].length) delete st.sel[k];
    st.pages = 1;
    // An occasion ticked during a search filters what it found (since 15 Oct); until then it threw the search away.
    update(false);
    /* A current finder was told the occasion (&occ=): a different occasion asks it again, for that occasion, rather
       than filtering an answer given for another (25 Oct). An older finder's answer is filtered as before. */
    if (k === 'occ' && st.q && st.v2 && !st.busy && occOf() !== (st.askedOcc || '')) ask(null, 'occasion');
  }
  let lastOpener = null;
  function setSheet(on) {
    if (on) lastOpener = document.activeElement;
    st.sheet = on;
    render();
    if (on) { const x = $('[data-rdf-sheet-close]'); if (x) x.focus(); } else if (lastOpener && lastOpener.isConnected) lastOpener.focus(); else { const b = $('[data-open-sheet]'); if (b) b.focus(); }
  }

  /* The search box's clear button (Daniel, 13 Oct): shown only while the field has words in it; it empties the field,
     takes the list back to unsearched when a search was showing, and leaves the caret in the field. Escape does the
     same. The browser's own clear button is hidden in rd-finding.css so there is one ✕, not two. */
  function syncClear() {
    root.querySelectorAll('[data-rdf-q]').forEach((i) => { const b = i.parentNode.querySelector('[data-rdf-clear]'); if (b) b.hidden = !i.value; });
  }
  function clearQ(i) {
    if (!i) return;
    i.value = '';
    if (st.q) clearSearch();
    i.focus();
    syncClear();
  }
  /* ---- events ------------------------------------------------------------------------------------------------ */
  root.addEventListener('click', (e) => {
    const t = e.target.closest('button');
    if (!t || !root.contains(t)) return;
    if (t.getAttribute('aria-disabled') === 'true') return;
    if (t.hasAttribute('data-k')) toggle(t.getAttribute('data-k'), t.getAttribute('data-v'));
    else if (t.hasAttribute('data-drop-k')) toggle(t.getAttribute('data-drop-k'), t.getAttribute('data-v'));
    else if (t.hasAttribute('data-clear-all')) { st.sel = {}; st.pages = 1; update(false); }
    else if (t.hasAttribute('data-clear-filters')) { const o = st.sel.occ; st.sel = o && (!st.q || onHost()) ? { occ: o } : {}; /* a search's filters all go, an occasion ticked on it too */ st.pages = 1; update(false); }
    else if (t.hasAttribute('data-more')) { const k = t.getAttribute('data-more'); st.open[k] = !st.open[k]; update(false); }
    else if (t.hasAttribute('data-more-cards')) addMore(true);
    else if (t.hasAttribute('data-open-sheet')) setSheet(true);
    else if (t.hasAttribute('data-rdf-sheet-close') || t.hasAttribute('data-rdf-show')) setSheet(false);
    else if (t.hasAttribute('data-rdf-clear')) clearQ(t.parentNode.querySelector('[data-rdf-q]'));
    else if (t.hasAttribute('data-clear-q')) { clearSearch(); const i = $('[data-rdf-finder] input'); if (i) i.focus(); }
    else if (t.hasAttribute('data-term')) dropTerm(+t.getAttribute('data-term'));
  });
  /* A search's card opened (25 Oct): where it was in the list, and whether it was a match, one of the closest or a
     generic card. Read before the lightbox (rd-design.js, on the document) takes the click. */
  root.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a.rdf-tile');
    if (!a || !st.q || !G || !st.view) return;
    const cells = Array.prototype.slice.call($('[data-rdf-grid]').querySelectorAll('.rdf-cell'));
    const i = cells.indexOf(a.closest('.rdf-cell')), d = i >= 0 ? G.shown[i] : null;
    if (!d) return;
    track('pp_search_open', { q: st.q, rank: i + 1, kind: st.view.mode === 'none' ? 'generic' : st.view.mode === 'match' && i < st.view.match ? 'exact' : 'near',
      design: d.id, page: pageKind(), occ: occOf() || null, shown: G.shown.length, country: F.countryBucket ? F.countryBucket() : null });
  });
  root.addEventListener('input', (e) => { if (e.target.matches && e.target.matches('[data-rdf-q]')) syncClear(); });
  root.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !e.target.matches || !e.target.matches('[data-rdf-q]') || !e.target.value) return;
    e.preventDefault(); e.stopPropagation();
    clearQ(e.target);
  });
  root.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-sort]')) { st.sort = t.value; st.pages = 1; update(false); }
    else if (t.matches('[data-pick]')) { const k = t.getAttribute('data-pick'); if (t.value) st.sel[k] = [t.value]; else delete st.sel[k]; st.pages = 1; update(false); }
  });
  root.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-rdf-search]');
    if (!f) return;
    e.preventDefault();
    const q = String(new FormData(f).get('q') || '').replace(/\s+/g, ' ').trim().slice(0, 160);
    if (!q) { f.querySelector('input').focus(); return; }
    /* ⛔ A NEW SEARCH STARTS CLEAN (25 Oct): the filters from before go, so a "Patterns with Meaning" left ticked can
       never empty it. The page's own occasion stays (an occasion's page, or one occasion ticked, which draws as that
       page): the search is asked for it (&occ=). Filters ticked after the search work on its results. */
    const o = occOf();
    st.sel = o ? { occ: [o] } : {};
    st.q = q; st.read = null; st.res = null; st.near = null; st.exact = null; st.note = ''; st.searchFailed = false; st.pages = 1;
    update(true);
    ask(null, 'typed');
    const h = $('[data-rdf-searchhead]');
    if (h && h.scrollIntoView) h.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  $('[data-rdf-sheet]').addEventListener('click', (e) => { if (e.target.hasAttribute('data-rdf-scrim')) setSheet(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && st.sheet) setSheet(false); });
  /* Back and forward. The design lightbox moves the address too (to the design's and back again): that is not a new
     list, so the list is left exactly as it is, with its cards, its "Show more" and the focus on the card. */
  const listKey = () => JSON.stringify([st.sel, st.sort, st.q, EMBED && EMBED.find ? EMBED.find.q() : '']);
  window.addEventListener('popstate', () => {
    if (onDesign(new URLSearchParams(location.search)) && F.designs()) return;
    const before = listKey();
    readAddress();
    if (listKey() === before) return;
    if (!st.q) cancelAsk();
    render(); if (st.q && !st.res) ask(null, 'back');
  });
  phoneMq.addEventListener('change', render);
  wideMq.addEventListener('change', render);

  /* ---- start ------------------------------------------------------------------------------------------------- */
  readAddress();
  let shownKey = listKey(), drawnSer = '';
  const back = cameBack();
  if (back) st.pages = back.pages;
  render();
  /* With the Artist Pool, so the Series filter and "Series for …" name each series by its title (pp-series.js). */
  Promise.all([F.load(), F.loadPool().catch(() => null)]).then(() => {
    root.classList.remove('is-loading');
    render();
    if (back && !st.q) window.scrollTo(0, back.y);
    if (st.q && !st.res && !st.busy) ask(null, 'address');   // a search sent while the cards were loading is already asking
  }).catch(() => {
    root.classList.remove('is-loading');
    $('[data-rdf-grid]').innerHTML = '';
    $('[data-rdf-notes]').innerHTML = F.notice('error', 'The cards did not load. Refresh the page to try again.');
  });
  return { render };
  }
  window.RDF_CARDS = { mount };
  /* Liked designs (assets/pp-likes.js, behind ?pplikes=1): &liked=1 draws the saved designs into this page's list, so
     the list is not mounted (templates/page.cards.liquid sets the flag). */
  if (!window.PP_LIKED_VIEW) mount(document.querySelector('[data-rdf-list]:not([data-embed])'), null);
})();
